import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as Objects from '@core/objects';
import { AddVersion, AddVersionErrors } from '@core/models/add-version';

export interface AddVersionState {
    data: AddVersion | null;
    savedVersion: Objects.Version | null; // Stores the submitted version
    creatingNewVersion: boolean;
    saved: boolean;
    errors: AddVersionErrors;
}

export const initialState: AddVersionState = {
    data: null,
    savedVersion: null,
    creatingNewVersion: false,
    saved: false,
    errors: {
        files: false,
        labels: false,
        version: false, // the version and subversion numbers
        status: false,
        forbidden: false,
        unauthorized: false,
        server: false,
        other: false
    }
};

export const addVersionFeatureSelector = createFeatureSelector<AddVersionState>('new_version');

export const addVersionSelector = createSelector(
    addVersionFeatureSelector,
    (state: AddVersionState) => state.data
);

export const addVersionErrorsSelector = createSelector(
    addVersionFeatureSelector,
    (state: AddVersionState) => state.errors
);

export const savedVersionSelector = createSelector(
    addVersionFeatureSelector,
    (state: AddVersionState) => state.savedVersion
);

export const creatingNewVersionSelector = createSelector(
    addVersionFeatureSelector,
    (state: AddVersionState) => state.creatingNewVersion
);

export const savedSelector = createSelector(
    addVersionFeatureSelector,
    (state: AddVersionState) => state.saved
);